import { FC } from 'react';
import { Link, Route, Routes } from 'react-router-dom';
// import useSWR from 'swr'
import Button from 'components/Button';
// import Mentorship from 'types/Mentorship'

// type RetrievedData = { mentorship: Mentorship | undefined }
const MenteeButtonRoutes: FC<{ menteeId: number | undefined }> = ({
  menteeId,
}) => {
  // const { mentorship }: RetrievedData = useSWR(`/mentorship/mentee/${menteeId}/ongoing/`).data || { mentorship: undefined };

  return (
    <Routes>
      <Route
        path=""
        element={
          <Link to={`/admin/mentoring/mentees/${menteeId}/edit-information`}>
            <Button variant="outlined">
              Modifier les informations générales
            </Button>
          </Link>
        }
      />

      {/* 
			DISABLED
			<Route path="form" element={
				<Button variant='outlined'>
					Modifier le formulaire
				</Button>
			} /> */}

      {/* 
			DISABLED
			<Route path="mentoring" element={
				!mentorship ? null : <Link to={`/admin/mentoring/mentees/${menteeId}/mentoring/associate`} ><Button variant="outlined">Créer un nouveau mentorat</Button></Link>
			} /> */}
    </Routes>
  );
};

export default MenteeButtonRoutes;
